import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { GetRollfiCompanies } from 'domain/usecases';

import { RemoteGetRollfiCompanies } from 'data/usecases/rollfi';

export const makeGetRollfiCompanies = (): GetRollfiCompanies => {
  return new RemoteGetRollfiCompanies(makeApiUrl('/rollfi/companies'), makeAuthorizeHttpClientDecorator());
};
